var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"grid-list-md":"","fluid":""}},[_c('h2',{staticClass:"display-3"},[_vm._v(_vm._s(_vm._f("t")(['account-manage_page-title', 'global_manage-account'])))])])}
var staticRenderFns = []

export { render, staticRenderFns }